import { Component,Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from "@irb/app.service";
import {PageService} from "@irb-common/services/page.service";
import {Router} from "@angular/router";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {IrbDashboardService} from "@irb/irb-dashboard/irb-dashboard.service";
import {UtilityService} from "@irb-common/services/utility.service";
import { faChevronRight, faClock } from '@fortawesome/free-solid-svg-icons';
import { IApplyFilterOnLanding } from '@irb/app.model';
import {IAutoRebalancePortfolioData, IAutoRebalanceOrderData} from '@irb/irb-dashboard/irb-dashboard.service';
import {IGlobalSettings} from "@irb/irb-dashboard/irb-dashboard.model";
import {IrbSettingsEvents} from "@irb/irb-settings/irb-settings.events";
@Component({ standalone: false,
  selector: 'irb-com-auto-rebalancing-widget',
  templateUrl: './com-auto-rebalancing-widget.component.html',
  styleUrls: ['./com-auto-rebalancing-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComAutoRebalancingWidgetComponent implements OnInit {
  @Input()
  globalSettings: IGlobalSettings;
  faChevronRight = faChevronRight;
  faClock = faClock;
  
  autoRebalancePortfolioData: IAutoRebalancePortfolioData;
  autoRebalanceOrderData: IAutoRebalanceOrderData;
  timestamp: string;
  currentDate: string;
  nextDate: string;
  nullstate = false;
  isUserAutoRebalanceEnabled= false;
  selectedIndex: number = 0;

  constructor(public as: AppService,
              public ps: PageService,
              private router: Router,
              private dbs: IrbDashboardService,
              private util: UtilityService,
              private ats: AnalyticsService) {
    this.timestamp = '';
  }

  ngOnInit(): void {
    this.getAutoRebalanceData();
  }

  getAutoRebalanceData() {
    this.autoRebalancePortfolioData = null;
    this.autoRebalanceOrderData = null;
    
    const currentDate = new Date();
	this.currentDate = currentDate.toLocaleString('en-US', {timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'});
	let d = this.util.getEasternTime(new Date().getTime());
    this.timestamp = this.util.formatDateTimeString(new Date(d), "MM/dd/yyyy hh:mm tt") + ' ET';
    this.ps.getUserDetails().subscribe((d: any) => {
      if (d) {
        this.isUserAutoRebalanceEnabled = d.isAutomationEnabled;
        this.dbs.getAutoRebalancePortfolioData().subscribe((response: any) => {
            this.autoRebalancePortfolioData = response || {};
            this.nullstate = !this.autoRebalancePortfolioData.autoRebalPfExist;
            //test data -----------------
            //  this.nullstate = false;
            //  this.autoRebalancePortfolioData.nextAutoRebalDate = '01/09/2025';
            //  this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount = 5;
            //  this.autoRebalancePortfolioData.autoRebalPfNoOrdersCount = 1;
            //  this.autoRebalancePortfolioData.autoRebalPfOrdersCount = 2;
            //  this.autoRebalancePortfolioData.autoRebalErrorCount = 3;
            //  this.autoRebalancePortfolioData.totalAutoRebalPfCount = 6;
            //--------------------------
			      this.nextDate = this.autoRebalancePortfolioData.nextAutoRebalDate || '';
			      this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount = this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount || 0;

            if(this.autoRebalancePortfolioData.totalAutoRebalPfCount > 0) {
              this.dbs.getAutoRebalanceOrderData().subscribe((response: any) => {
                this.autoRebalanceOrderData = response || {};
                //test data -----------------
                // this.autoRebalanceOrderData.approvedCount = 5;
                // this.autoRebalanceOrderData.errorCount = 0;
                // this.autoRebalanceOrderData.submitedCount = 0;
                // this.autoRebalanceOrderData.totalCount = 5;
                //---------------------------
              });
            } else {
              this.autoRebalanceOrderData = {} as IAutoRebalanceOrderData;
            }
        });
      }
    });
  }

  goToPortfolios() {
    this.ats.trackPassiveEvent("lc_ports");
    this.router.navigate(['/clients/portfolios']);
  }

  refreshWidgetData() {
    this.getAutoRebalanceData();
  }
  
  showAutoRebalPfErrors() {
    const state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance Error','Trade Error','Order error'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }
  
  showAutoRebalPfOrders() {
    const state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance with Orders'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }

  showAutoRebalPfNoOrders() {
    const state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance without Orders'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }

  showAutoRebalPending() {
    const state = {
      isUpdatRequired: false,
      tabname:'Automated'
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  
  showAutoRebalError() {
    const d = new Date(this.util.getEasternTime(new Date().getTime()));
    let today = this.util.formatDateTimeString(d, "yyyy-MM-dd");

    const state = {
      isUpdatRequired: true,
      tabname:'Closed',
      filterModels: [
        { name: 'orderStatus', value: ["Canceled"], isUpdatRequired: true },
        { name: 'ticketType', value: ["A"], isUpdatRequired: true },
        { name: 'modifiedDate', value: {dateFrom: today, dateTo: today}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  showAutoRebalPfScheduled() {
    const state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'nextRebalDate', value: {dateFrom: this.getNextDate(), dateTo: this.getNextDate()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }
  showAutoRebal() {
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      tabname:'Closed',
      filterModels: [
        { name: 'orderStatus', value: ["Submitted","Filled"], isUpdatRequired: true },
        { name: 'ticketType', value: ["A"], isUpdatRequired: true },
        { name: 'modifiedDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  showGlobalSettingsDialog() {
	this.as.setToLocal("LAST_TAB_INDEX", 6);
    this.as.fireEvent(IrbSettingsEvents.SHOW);
  }
  getToday() {
    const d = new Date(this.util.getEasternTime(new Date().getTime()));
    return this.util.formatDateTimeString(d, "yyyy-MM-dd");
  }
  getNextDate() {
	const mm= this.nextDate.substring(0,2);
	const dd = this.nextDate.substring(3,5);
	const yyyy = this.nextDate.substring(6,10);
	return yyyy + '-' + mm + '-' + dd;
  }
}
